<template>
  <div>
    <vs-table
      search
      stripe
      border
      description
      :data="table.data"
      :max-items="table.length"
      :sst="false"
      @change-page="handleChangePage"
      :total="table.total"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>

      <template slot="thead">
        <vs-th>Action</vs-th>
        <vs-th>Territory</vs-th>
        <vs-th>Salesman Name</vs-th>
        <vs-th>Date</vs-th>
        <vs-th>Start Session At</vs-th>
        <vs-th>End Session At</vs-th>
        <vs-th>Total Customer Visited</vs-th>
        <vs-th>Total Customer Not Visited</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="whitespace-no-wrap">
            <div class="vx-input-group flex">
              <vs-button
                  @click="onClickBtnDetail(tr)"
                  size="small"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-eye"
                  title="Detail"
                  style="margin-right: 5px"
              />
              <vs-button
                  v-show="tr.EndSession == '00:00:00'"
                  @click="onClickForceEnd(tr)"
                  size="small"
                  color="success"
                  icon-pack="feather"
                  icon="icon-navigation"
                  title="Force End Session"
                  style="margin-right: 5px"
              />
            </div>
          </vs-td>
          <vs-td>{{ tr.TerritoryName }}</vs-td>
          <vs-td>{{ tr.PersonalName }}</vs-td>
          <vs-td>{{ dateFormat(tr.Date) }}</vs-td>
          <vs-td>{{ tr.StartSession }}</vs-td>
          <vs-td>{{ tr.EndSession }}</vs-td>
          <vs-td>{{ tr.TotalCustomerVisited }}</vs-td>
          <vs-td>{{ tr.TotalCustomerNonVisited }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />

    <vs-prompt
        @accept="onSendApproval"
        :active.sync="modalReason.activeModalReason"
        title="Confirm"
        accept-text="Confirm"
    >
      <div class="con-example-prompt">
        <div>
          <span>Reason</span>
        </div>
        <div>
          <multiselect class="selectExample" v-model="reason.selected" :options="reason.options" label="reason" />
        </div>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { formatNumber } from "@/utils/common";
import moment from "moment";
export default {
  data() {
    return {
      baseUrl: "/api/sfa/v1/daily-closing/monitoring-salesman-not-yet-end-session",
      table: this.tableDefaultState(),
      date: "",
      personalIDs: [],
      reason: {
        selected: null,
        options: [],
      },
      modalReason: {
        activeModalReason: false,
      },
      itemSelected: null,
    };
  },
  methods: {
    formatNumber,
    dateFormat(date) {
      if (date != null) {
        date = moment(date).format("DD MMM YYYY");
      }

      return date
    },
    async setDate(date) {
      this.date = date;
    },
    async setPersonalIDs(personalIDs) {
      this.personalIDs = personalIDs;
    },
    async setTerritoryIDs(territoryIDs) {
      this.territoryIDs = territoryIDs;
    },
    async setStatus(value) {
      this.status = value;
    },
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [5, 10, 25, 50, 100, "All"],
        start: 1,
        end: 0
      };
    },
    onClickBtnDetail(data) {
      this.$router.push({
        name: "monitoring-salesman-show",
        query: {
          date: moment(data.Date).format("YYYYMMDD"),
          personal_id: data.PersonalID,
          territory_id: data.TerritoryID,
        }
      });
    },
    async getData() {
      /*if (this.date == "") {
        return;
      }*/
      this.$vs.loading();
      try {
        const params = {
          date: this.date ? this.date : moment().format('YYYY-MM-DD'),
          territory_id: this.territoryIDs ? this.territoryIDs : null,
          status: this.status ? this.status : 0,
          page: this.table.page,
          length: this.table.length,
          search: this.table.search,
          order: this.table.order,
          sort: this.table.sort,
        }

        const response = await this.$http.get(this.baseUrl, {
          params
        });
        if (response.code == 200) {
          this.table.total = response.data.total_record;
          this.table.totalPage = response.data.total_page;
          this.table.totalSearch = response.data.total_record_search;
          this.table.length = response.data.total_record_per_page;
          this.table.data = response.data.records;

          this.setStartEnd();
        } else {
          this.$vs.notify({
            title: "Error",
            text: response.message,
            color: "danger",
            position: "top-right",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error.message,
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      }
      this.$vs.loading.close();
    },
    getDataReason() {
      this.$vs.loading();
      this.$http
          .get("/api/oms/v1/sfa-master/reason-active", {
            params: {
              order: "code",
              sort: "asc",
              reason_group: "Force End Session",
              is_active: true
            },
          })
          .then((resp) => {
            if (resp.status == "success") {
              this.reason.options = resp.data.records;
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
            }
          });
    },
    onSendApproval(){
      if (!this.reason.selected) {
        return this.$vs.notify({
          title: "Error",
          text: "Please select a reason",
          color: "danger",
          position: "top-right",
        })
      }

      this.$vs.loading()
      this.$http.post(`${this.baseUrl}/force-end-session`, {
        // customer_visit_id: this.itemSelected.CustomerVisitID,
        territory_id: this.itemSelected.TerritoryID,
        reason_id: this.reason.selected.ID,
        reason_text: this.reason.selected.reason,
        personal_id: this.itemSelected.PersonalID,
        date: this.itemSelected.Date,
        // customer_id: this.itemSelected.CustomerID,
      }).then((response) => {
        if(response.code == 200) {
          this.$vs.notify({
            title: "success",
            text: "Success Send Approval Force End Session Salesman",
            color: "success",
            position: "top-right",
          });
        } else {
          this.$vs.notify({
            title: "Error",
            text: response.message,
            color: "danger",
            position: "top-right",
          });
        }
      }).finally(() => {
        this.$vs.loading.close();
      })
    },
    onClickForceEnd(data){
      this.reason = {
        selected: null,
        options: [],
      }
      this.itemSelected = null
      this.getDataReason()
      this.modalReason.activeModalReason = !this.modalReason.activeModalReason
      this.itemSelected = {
        TerritoryID: data.TerritoryID,
        PersonalID: data.PersonalID,
        Date: moment(data.Date).format("YYYY-MM-DD"),
      }
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
  },
  computed: {
    setPage: {
      get() {
        return this.table.page;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
